<template>
  <div v-if="User.user.role != $roleConsts.ORG.value">
    <el-descriptions
      class="margin-top"
      title="身份信息"
      border
      :column="UI.clientWidth < 1000 ? 1 : 3"
      :labelStyle="{ width: UI.clientWidth < 1000 ? '120px' : '120px' }"
    >
      <template slot="extra">
        <el-button
          v-if="
            User.user.role == $roleConsts.PLAYER.value ||
              User.user.role == $roleConsts.TECH_OFFICER.value
          "
          type="primary"
          size="small"
          @click="toApproved()"
        >
          {{ User.user_info.name ? '点击修改' : '注册信息' }}
        </el-button>
      </template>
      <el-descriptions-item>
        <template slot="label">
          姓名
        </template>
        {{ User.user_info.name }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          性别
        </template>
        <el-tag
          size="small"
          :type="User.user_info.sex == 0 ? 'primary' : 'danger'"
        >
          {{ User.user_info.sex == 0 ? '男' : '女' }}
        </el-tag>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          民族
        </template>
        {{ User.user_info.nation }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          籍贯
        </template>
        {{
          User.user_info.native_place ? User.user_info.native_place.join() : ''
        }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          手机
        </template>
        {{ User.user_info.mobile }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          邮箱
        </template>
        {{ User.user_info.email }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          证件类型
        </template>
        {{ User.user_info.identifier_type == 0 ? '身份证' : '其他' }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          证件号码
        </template>
        {{ User.user_info.identifier_code }}
      </el-descriptions-item>

      <el-descriptions-item
        v-if="User.user.role == $roleConsts.ORG_PLAYER.value"
      >
        <template slot="label">
          身份证扫描件
        </template>
        <el-button
          size="mini"
          :disabled="!User.user_info.identifier_image"
          @click="
            fileUrl = User.user_info.identifier_image;
            isShow = true;
          "
          :type="
            User.user_info.identifier_image
              ? approveBtn[User.user_info.is_approved]
              : 'danger'
          "
        >
          {{
            User.user_info.identifier_image
              ? $getApproveLabel(User.user_info.is_approved)
              : '未上传'
          }}
        </el-button>
      </el-descriptions-item>

      <el-descriptions-item
        v-if="User.user.role == $roleConsts.ORG_PLAYER.value"
      >
        <template slot="label">
          户籍证明
        </template>
        <el-button
          size="mini"
          :disabled="!User.user_info.household_image"
          @click="
            fileUrl = User.user_info.household_image;
            isShow = true;
          "
          :type="
            User.user_info.household_image
              ? approveBtn[User.user_info.is_approved]
              : 'danger'
          "
        >
          {{
            User.user_info.household_image
              ? $getApproveLabel(User.user_info.is_approved)
              : '未上传'
          }}
        </el-button>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          出生日期
        </template>
        {{ User.user_info.identifier_code ? User.user_info.birthday : '' }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          通讯地址
        </template>
        {{ User.user_info.address }}
      </el-descriptions-item>

      <el-descriptions-item v-if="User.user.role == $roleConsts.TECH_OFFICER.value || (User.user.extra_roles || []).includes($roleConsts.TECH_OFFICER.value)">
        <template slot="label">
          裁判培训等级
        </template>
        {{ User.user_info.referee_level ? User.user_info.referee_level : '无' }}
      </el-descriptions-item>

      <el-descriptions-item v-if="User.user.role == $roleConsts.TECH_OFFICER.value || (User.user.extra_roles || []).includes($roleConsts.TECH_OFFICER.value)">
        <template slot="label">
          赛事履历
        </template>
        {{ User.user_info.referee_resume }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          签名
        </template>
        <el-button 
        type="primary"
        size="mini" 
        @click="
          fileUrl = User.user_info.sign;
          isShow = true;
        " 
        :disabled="! User.user_info.sign">
          查看
        </el-button>
      </el-descriptions-item>

      <el-descriptions-item
        v-if="User.user.role == $roleConsts.ORG_PLAYER.value || (User.user.extra_roles || []).includes($roleConsts.ORG_PLAYER.value)"
      >
        <template slot="label">
          协议时间
        </template>
        {{ User.user_info.contract_start_time }} ->
        {{ User.user_info.contract_end_time }}
      </el-descriptions-item>

      <el-descriptions-item
        v-if="User.user.role == $roleConsts.ORG_PLAYER.value || (User.user.extra_roles || []).includes($roleConsts.ORG_PLAYER.value)"
      >
        <template slot="label">
          代表资格协议
        </template>

        <el-button
          size="mini"
          :disabled="!User.user_info.contract"
          @click="
            fileUrl = User.user_info.contract;
            isShow = true;
          "
          :type="
            User.user_info.contract
              ? approveBtn[User.user_info.is_approved]
              : 'danger'
          "
        >
          {{
            User.user_info.contract
              ? $getApproveLabel(User.user_info.is_approved)
              : '未上传'
          }}
        </el-button>
      </el-descriptions-item>
      <el-descriptions-item v-else>
        <template slot="label">
          状态
        </template>
        <el-tag size="small" :type="approveBtn[User.user_info.is_approved]">
          {{ $getApproveLabel(User.user_info.is_approved) }}
        </el-tag>
      </el-descriptions-item>
    </el-descriptions>
    <el-dialog
      show-close
      :fullscreen="UI.isMobile"
      title="查看"
      :visible.sync="isShow"
      width="800px"
    >
      <pdf :src="fileUrl" v-if="fileUrl.endsWith('pdf')"></pdf>
      <img v-else :src="fileUrl" style="max-width: 500px;"></img>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import pdf from '@/components/pdfShow.vue';
import { showErrorMsg } from '@/utils/uiUtils.js';

export default {
  components: {
    pdf,
  },

  computed: {
    ...mapState(['User', 'UI']),
  },

  data() {
    return {
      fileUrl: '',
      isShow: false,
      approveBtn: ['warning', 'success', 'danger', 'info'],
    };
  },

  methods: {
    toApproved: function() {
      if (
          this.User.user_info.is_approved == this.$approveConsts.APPROVED.value
        ) {
          showErrorMsg('信息已审核，请先联系管理员驳回');
        } else {
          this.$router.push({ name: 'userInfoApprove' });
        }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/index/info/userInfo.vue